import ServiceBase from '../ServiceBase';

export default class BusinessAccountAdminService extends ServiceBase {
    getOnboardingLocations() {
        return this.request('get', 'admin/businessAccount/getOnboardingLocations');
    }

    getSupportedLocationsForShareholders() {
        return this.request('get', 'admin/businessAccount/getSupportedLocationsForShareholders');
    }

    getSupportedLocationsForSubmerchants() {
        return this.request('get', 'admin/businessAccount/getSupportedLocationsForSubmerchants');
    }

    resetMerchantData(request) {
        return this.request('post', 'admin/businessAccount/resetMerchantData', request);
    }

    getOnboardingCurrencies(creatorID, locationID = null, projectID = null) {
        return this.request('get', 'admin/businessAccount/getOnboardingCurrencies', { creatorID, locationID, projectID });
    }

    changeBankAccount({ projectID, currencyID, subMerchantBankAccountID }) {
        return this.request('post', 'admin/businessAccount/changeBankAccount', { projectID, currencyID, subMerchantBankAccountID });
    }

    changeProjectCurrency({ projectID, currencyID }) {
        return this.request('post', 'admin/businessAccount/changeProjectCurrency', { projectID, currencyID });
    }
}